import * as types from '../constants/ActionTypes';
import { getFormattedPhoneNumber } from '../../lib/date-helper';

const initialState = {
  error: false,
  loaded: false,
  isLoading: false,
  racInfo: undefined,
  status: false,
  isPrimary: true,
};

function secondsToMinutes(secs) {
  if (secs >= 0 && typeof secs === 'number') {
    return Math.floor(secs / 60);
  }
  return -1;
}
/*
function formatPhoneNumber(phn) {
  return phn.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
} */

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_RAC_ELIGIBILITY:
      return {
        ...state,
        loaded: false,
        isLoading: true,
        error: false,
        racInfo: undefined,
        alertFpti: false,
      };
    case types.RECEIVE_RAC_ELIGIBILITY: {
      // phoneNum: action.payload.phone_details[0].phone.national_number || '9999999999',
      // formattedPhoneNum: formatPhoneNumber(action.payload.phone_details[0].phone.national_number),
      // enabled: action.payload.request_a_call_enabled,
      // segment_name: action.payload.segment_name || 'na_limitations_unauth_acct_access_event',
      // if phoneNum is undefined then we dont show rac during rendering
      const ctrCode = ((((action.payload || {}).phone_details || [])[0] || {}).phone || {}).country_code || 1;
      const phn = ((((action.payload || {}).phone_details || [])[0] || {}).phone || {}).national_number || null;
      return {
        ...state,
        loaded: true,
        isLoading: false,
        error: false,
        racInfo: action.payload,
        enabled: (action.payload || {}).request_a_call_enabled || false,
        countryCode: ((((action.payload || {}).phone_details || [])[0] || {}).phone || {}).country_code || 1,
        formattedPhoneNum: getFormattedPhoneNumber(ctrCode, phn),
        ewt: secondsToMinutes((action.payload || {}).estimated_wait_time),
        phoneNum: ((((action.payload || {}).phone_details || [])[0] || {}).phone || {}).national_number,
        segment_name: (action.payload || {}).segment_name || null,
      };
    }
    case types.RECEIVE_RAC_ELIGIBILITY_ERROR:
      return {
        ...state,
        loaded: true,
        isLoading: false,
        error: true,
        racInfo: undefined,
      };
    case types.RAC_SHOWPOPUP:
      return {
        ...state,
        status: true,
        isPrimary: true,
        alertFpti: true,
      };
    case types.RAC_HIDEPOPUP:
      return {
        ...state,
        status: false,
        isPrimary: true,
      };
    case types.RAC_GET_NEWNUM:
      return {
        ...state,
        isPrimary: false,
        input: '',
      };
    case types.RAC_GET_PRIMARY:
      return {
        ...state,
        isPrimary: true,
        input: '',
      };
    case types.REQUEST_RAC_SUBMIT:
      return {
        ...state,
        loaded: false,
        isLoading: true,
        error: false,
        racNumber: action.payload,
        racFormattedNumber: getFormattedPhoneNumber((action.payload || {}).code, (action.payload || {}).num),
      };
    case types.RECEIVE_RAC_SUBMIT:
      return {
        ...state,
        loaded: true,
        isLoading: false,
        error: false,
        racSuccess: true,
        status: false,
        racSubmit: true,
      };
    case types.REQUEST_RAC_SUBMIT_FAIL:
      return {
        ...state,
        loaded: true,
        isLoading: false,
        error: false,
        racSuccess: false,
        racSubmit: true,
        status: false,
        messageCode: ((action.payload || {}).info || {}).message || null,
      };
    case types.RECEIVE_RAC_SUBMIT_ERROR:
      return {
        ...state,
        loaded: true,
        isLoading: false,
        error: false,
        racSuccess: false,
        racSubmit: true,
        status: false,
        messageCode: 'apologizeError',
      };
    default:
      return state;
  }
}
